import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  type NormalizedCacheObject,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { auth } from "components/firebase";
import { packingTypePolicies } from "./packingCache";

type ApolloClientInstance = ApolloClient<NormalizedCacheObject>;

const httpLink = createHttpLink({
  uri: "/graphql",
});

const authLink = setContext(async (_, { headers }) => {
  const token = await auth?.currentUser?.getIdToken();

  return {
    headers: {
      ...headers,
      authorization: token || "",
      version: "2.0.30",
      // Tells the server this is web (servesTripListsUnscoped, 123yb696d1x): web always gets the new lists rule.
      "x-stippl-client": "web",
    },
  };
});

const client: ApolloClientInstance = new ApolloClient({
  link: authLink.concat(httpLink),
  name: import.meta.env.MODE,
  connectToDevTools: import.meta.env.DEV,
  version: "1.0",
  cache: new InMemoryCache({
    typePolicies: {
      TripDestination: {
        keyFields: ["_id"],
        merge: true,
      },
      DestinationResearch: {
        merge: true,
      },
      Place: {
        keyFields: ["_id"],
      },
      List: {
        keyFields: ["_id"],
      },
      ...packingTypePolicies,
    },
  }),
});

export { client };
export default client;
